import * as angular from 'angular';

class SecondaryDetailsRowComponentCtrl implements ng.IController {
    label: string;

    $onInit() {}
}

angular.module('app').component('pkpSecondaryDetailsRow', {
    controller: SecondaryDetailsRowComponentCtrl,
    template: require('app/secondary-trading/secondary-details-row.component.html'),
    bindings: {
        label: '<'
    },
    transclude: {
        label: 'pkpSecondaryDetailsLabel',
        value: 'pkpSecondaryDetailsValue'
    }
});
